import { aiApi } from '~/modules/query/ai';
import type {
  AddConfiguredModelRequest,
  AddConfiguredModelResponse,
  ConfiguredModelsResponse,
  FieldCatalogResponse,
  ListAgentsResponse,
  ModelsResponse,
  RemoveConfiguredModelResponse,
  UpdateProviderModelConfigRequest,
  UpdateProviderModelConfigResponse,
} from '~/modules/query/ai/types';

export const providersApi = aiApi.injectEndpoints({
  endpoints: (builder) => ({
    getProviders: builder.query<ModelsResponse, void>({
      query: () => ({ url: '/manager/providers', method: 'GET' }),
      providesTags: ['AiProviders', 'AiProviderModels'],
    }),
    updateProviderModel: builder.mutation<
      UpdateProviderModelConfigResponse,
      UpdateProviderModelConfigRequest
    >({
      query: (data) => ({ url: '/manager/providers/models', method: 'PATCH', data }),
      invalidatesTags: ['AiProviders', 'AiProviderModels'],
    }),
    getConfiguredModels: builder.query<ConfiguredModelsResponse, void>({
      query: () => ({ url: '/manager/providers/configured', method: 'GET' }),
      providesTags: ['AiProviderModels'],
    }),
    addConfiguredModel: builder.mutation<AddConfiguredModelResponse, AddConfiguredModelRequest>({
      query: (data) => ({ url: '/manager/providers/configured', method: 'POST', data }),
      invalidatesTags: ['AiProviders', 'AiProviderModels'],
    }),
    removeConfiguredModel: builder.mutation<RemoveConfiguredModelResponse, string>({
      query: (modelId) => ({
        url: `/manager/providers/configured/${encodeURIComponent(modelId)}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AiProviders', 'AiProviderModels'],
    }),
    getFieldCatalog: builder.query<FieldCatalogResponse, void>({
      query: () => ({ url: '/manager/field-catalog', method: 'GET' }),
      providesTags: ['AiFieldCatalog'],
    }),
    getAgents: builder.query<ListAgentsResponse, void>({
      query: () => ({ url: '/manager/agents', method: 'GET' }),
      providesTags: ['AiAgents'],
    }),
  }),
});

export const {
  useGetProvidersQuery,
  useUpdateProviderModelMutation,
  useGetConfiguredModelsQuery,
  useAddConfiguredModelMutation,
  useRemoveConfiguredModelMutation,
  useGetFieldCatalogQuery,
  useGetAgentsQuery,
} = providersApi;
